export default "__VITE_ASSET___KdklywB__"